const initialState = {
  vendorQuotations: [],
  /** RFQ ids for which we already fetched the VQ list (even if empty). */
  loadedRfqIds: [],
  loading: false,
};

const vqKey = (vq) => String(vq?.POID ?? vq?.id ?? "");

const hasVqLines = (vq) =>
  Array.isArray(vq?.lineItems) && vq.lineItems.length > 0;

const mergeVqPreserveLines = (existing, incoming) => {
  if (!incoming) return existing || null;
  if (!existing) return incoming;
  const keepLines =
    !hasVqLines(incoming) && hasVqLines(existing)
      ? existing.lineItems
      : incoming.lineItems;
  const keepFetched = Boolean(existing.__detailFetched || incoming.__detailFetched);
  return {
    ...existing,
    ...incoming,
    lineItems: keepLines ?? existing.lineItems ?? incoming.lineItems ?? [],
    ...(keepFetched ? { __detailFetched: true } : {}),
  };
};

const vendorQuotationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_VENDOR_QUOTATIONS_FOR_RFQ": {
      const rfqId = String(action.rfqId ?? "");
      const incoming = Array.isArray(action.payload) ? action.payload : [];
      if (!rfqId) return state;

      const prevById = new Map(
        (state.vendorQuotations || []).map((v) => [vqKey(v), v])
      );
      const others = (state.vendorQuotations || []).filter(
        (v) => String(v.rfqId ?? v.RequestForQuotation_Id ?? "") !== rfqId
      );
      const forRfq = incoming.map((v) => {
        const id = vqKey(v);
        if (!id || id === "null") return v;
        return mergeVqPreserveLines(prevById.get(id), v);
      });
      const loadedRfqIds = state.loadedRfqIds.includes(rfqId)
        ? state.loadedRfqIds
        : [...state.loadedRfqIds, rfqId];
      return {
        ...state,
        vendorQuotations: [...forRfq, ...others],
        loadedRfqIds,
        loading: false,
      };
    }

    case "UPSERT_VENDOR_QUOTATION": {
      const incoming = action.payload;
      if (!incoming) return state;
      const id = vqKey(incoming);
      if (!id || id === "null") return state;
      const existing = (state.vendorQuotations || []).find((v) => vqKey(v) === id);
      const merged = mergeVqPreserveLines(existing, incoming);
      const vendorQuotations = existing
        ? (state.vendorQuotations || []).map((v) =>
            vqKey(v) === id ? merged : v
          )
        : [merged, ...(state.vendorQuotations || [])];
      const rfqId = String(merged.rfqId ?? merged.RequestForQuotation_Id ?? "");
      const loadedRfqIds =
        rfqId && !state.loadedRfqIds.includes(rfqId)
          ? [...state.loadedRfqIds, rfqId]
          : state.loadedRfqIds;
      return {
        ...state,
        vendorQuotations,
        loadedRfqIds,
        loading: false,
      };
    }

    default:
      return state;
  }
};

export default vendorQuotationsReducer;
export { mergeVqPreserveLines, hasVqLines };
